// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YSHyX","content":"styles_content__3LwoH","tableWrap":"styles_tableWrap__2QAbV"};